import {
  PlanningBoardEntryTypeOption,
  PlanningBoardFilterConfig,
} from '../_interfaces/base-planning-board-filter-config.interface';
import { PlanningBoardEntryType } from '../_enums/planning-board-entry-type.enum';

// Entry-type facet options for the PSP board. `id` matches the backend
// `PlanningBoardEntryType` value; `label` is an i18n key translated by the dropdown.
// Rendered only for the values the backend reports present (see filters component).
export const PLANNING_BOARD_ENTRY_TYPE_OPTIONS: ReadonlyArray<PlanningBoardEntryTypeOption> = [
  { id: PlanningBoardEntryType.FixedShift, label: 'planningBoard.entryType.fixedShift' },
  { id: PlanningBoardEntryType.FlexibleShift, label: 'planningBoard.entryType.flexibleShift' },
  { id: PlanningBoardEntryType.Absence, label: 'planningBoard.entryType.absence' },
  { id: PlanningBoardEntryType.FreeShift, label: 'planningBoard.entryType.freeShift' },
];

// Customer endpoint (`FilterListsResponse`) keys: `departments`, `customerLocations`,
// `mainQualifications`, `branches`.
export const CUSTOMER_PLANNING_BOARD_FILTERS: ReadonlyArray<PlanningBoardFilterConfig> = [
  {
    queryKey: 'customerDepartments',
    labelKey: 'department.singular',
    filtersField: 'departments',
    bindOptionLabel: 'name',
    optionSubLabelSegments: ['customerLocation', 'name'],
  },
  {
    queryKey: 'customerLocations',
    labelKey: 'location.singular',
    filtersField: 'customerLocations',
    bindOptionLabel: 'name',
  },
  {
    queryKey: 'mainQualifications',
    labelKey: 'qualifications.singular',
    filtersField: 'mainQualifications',
    bindOptionLabel: 'name',
  },
  {
    queryKey: 'pspBranches',
    labelKey: 'branch.singular',
    filtersField: 'branches',
    bindOptionLabel: 'name',
  },
];

// PSP endpoint (`FilterListsResponse2`) keys: `customers`, `customerDepartments`,
// `customerLocations`, `mainQualifications`, `pspBranches`.
export const PSP_PLANNING_BOARD_FILTERS: ReadonlyArray<PlanningBoardFilterConfig> = [
  {
    queryKey: 'customers',
    labelKey: 'customer.singular',
    filtersField: 'customers',
    bindOptionLabel: 'name',
  },
  {
    queryKey: 'customerDepartments',
    labelKey: 'department.singular',
    filtersField: 'customerDepartments',
    bindOptionLabel: 'name',
    optionSubLabelSegments: ['customerLocation', 'name'],
  },
  {
    queryKey: 'customerLocations',
    labelKey: 'location.singular',
    filtersField: 'customerLocations',
    bindOptionLabel: 'name',
  },
  {
    queryKey: 'mainQualifications',
    labelKey: 'qualifications.singular',
    filtersField: 'mainQualifications',
    bindOptionLabel: 'name',
  },
  {
    queryKey: 'pspBranches',
    labelKey: 'branch.singular',
    filtersField: 'pspBranches',
    bindOptionLabel: 'name',
  },
  {
    queryKey: 'entryTypes',
    labelKey: 'planningBoard.filter.entryType',
    filtersField: 'entryTypes',
    bindOptionLabel: 'label',
    staticOptions: PLANNING_BOARD_ENTRY_TYPE_OPTIONS,
  },
];

// Union of filter `queryKey`s across roles — used by URL-level operations
// (reset map, isFilterKey check, active-criteria count) that don't depend
// on role and must cover any param a user could land with.
export const PLANNING_BOARD_FILTER_QUERY_KEYS: ReadonlyArray<string> = Array.from(
  new Set([
    ...CUSTOMER_PLANNING_BOARD_FILTERS.map((c) => c.queryKey),
    ...PSP_PLANNING_BOARD_FILTERS.map((c) => c.queryKey),
  ])
);
